export default __webpack_public_path__ + "static/media/baker-health.png";